export enum WidgetChannelKind {
  vk = 'vk',
  tg = 'tg',
  wa = 'wa',
  vb = 'vb',
  ig = 'ig',
  ok = 'ok',
  max = 'max'
}

export interface IWidgetChannelServer {
  type: WidgetChannelKind;
  social_url: string;
}
